import { LucideMapPin, LucidePhone } from "lucide-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineMapPin, HiOutlinePhone } from "react-icons/hi2";
import { Badge } from "rsuite";
import contact from "../assets/contact.webp";
import { apiSend, getRoute } from "@services/axios";
import Swal from "sweetalert2";

const TopBanner = ({
  id,
  data,
  dynamicData,
  dynamicData1,
  dd,
  dd1,
  country,
  city,
  images,
  confirmation
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const putOnSale = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await apiSend(
        [getRoute("PUT_SALE"), id, "activate"].join("/"),
        "get"
      );
      console.log('put on sale', response);
       Swal.fire("produit mis en vente");
    } catch (err) {
      console.error('Error putting on sale:', err);
      setError(t("error_putting_on_sale"));
      // Optionally show error notification to user
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to determine status badge class
  const getStatusBadgeClass = () => {
    if (dd === "draft") return "status-pending";
    if (dynamicData1 === "pending") return "status-pending";
    if (dynamicData1 === "accepted") return "status-confirmed";
    if (dynamicData1 === "cancelled") return "status-cancelled";
    return "status-pending";
  };

  // Helper function to get status text
  const getStatusText = () => {
    if (dd === "draft") return t(dynamicData1);
    return t(dynamicData1);
  };

  const isButtonDisabled = dynamicData1 !== "accepted" || isLoading;
  const isBookable = dd === 1;

  return (
    <div className="rounded bg-white">
      <div>
        <div className="position-relative">
          <img
            src={images[0]?.image_url || contact}
            alt="hotel_img"
            className="rounded-end object-fit-cover w-100"
            style={{ height: '200px', objectFit: 'cover' }}
            loading="lazy"
          />
          <div 
            className="position-absolute bottom-0 start-0 p-2 text-white w-100 rounded-bottom" 
            style={{ background: 'linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent)' }}
          >
            <h5 className="mb-0">{data}</h5>
          </div>
        </div>

        <div className={`ms-4 mt-2 me-1 status-badge ${getStatusBadgeClass()}`}>
          {getStatusText()}
        </div>

        <Badge 
          className={`me-1 status-badge ${!isBookable ? "status-cancelled" : "status-completed"}`} 
          content={isBookable ? t("bookable") : t("non bookable")} 
        />
        
        <button 
          className="rounded-pill px-3 py-1 text-white" 
          style={{ backgroundColor: "#10b981" }} 
          onClick={putOnSale} 
          disabled={isButtonDisabled}
        >
          {isLoading ? t("processing") : t("on_sale")}
        </button>
        
        {error && <div className="text-danger small mt-1 ms-4">{error}</div>}
        
        <div className="fs-6 my-2 ps-4">
          <LucideMapPin className="text-blue" size={18} /> {city}, {country}
        </div>

        <div className="fs-6 mt-1 ps-4 pb-3">
          <LucidePhone className="text-blue" size={16} /> {t(dd1)}
        </div>
      </div>
    </div>
  );
};

export default TopBanner;